import React, { useMemo } from "react"

import { CardProduct } from "@app/scripts/components/card-product"
import { useSearchspringRecommendResults } from "@app/scripts/hooks/use-searchspring-recommend-results"
import { useSwatchCache } from "../hooks/use-swatches"
import { currentCountryCurrency } from "@app/scripts/lib/utils"
import {
  useShopifyPrice,
  mergeResultsWithPricing,
} from "@app/scripts/hooks/use-shopify"
export function SearchDrawerResults({ resultsData, recommendations = false }) {
  const results = recommendations
    ? useSearchspringRecommendResults()
    : resultsData

  const swatchColourData = useSwatchCache(results)

  // Formats data for useShopifyPrice
  const formattedProductData = useMemo(
    () =>
      results.map((result) => ({
        price: result.price || 0,
        compareAtPrice: result.msrp || 0,
        id: result?.attributes?.ss_id || "",
        handle: result?.attributes?.handle || "",
      })),
    [results]
  )

  // Formats data (returns new prices or AUD prices)
  const formattedPriceData = useShopifyPrice(
    formattedProductData,
    currentCountryCurrency
  )

  // Create new products array with updated price data or defaults back to results
  const productsWithUpdatedPrices = useMemo(() => {
    return mergeResultsWithPricing(results, formattedPriceData)
  }, [results, formattedPriceData])

  return (
    <>
      <div className="search-drawer--results-container">
        {productsWithUpdatedPrices?.length > 0 &&
          productsWithUpdatedPrices?.map((result) => (
            <div key={result?.uid} className="search-drawer--result-item">
              <CardProduct
                data={{ ...result, ...result.attributes }}
                instantSearch={true}
                modelToggle={true}
                swatchColours={swatchColourData}
                currentCountryCurrency={currentCountryCurrency}
              />
            </div>
          ))}
      </div>
    </>
  )
}
